import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "custom-quill" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "ql-formats" }
const _hoisted_4 = {
  key: 0,
  class: "ql-size"
}
const _hoisted_5 = {
  key: 1,
  class: "ql-align"
}

import { computed, onMounted, ref, watch } from "vue";
import { bsonId } from "@/common/utils/common";
import { QuillEditor, loadQuill } from "@vueup/vue-quill";
import Delta from "quill-delta";
import { styleZoom } from "@/common/utils/style";
import "@vueup/vue-quill/dist/vue-quill.snow.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-text-editor',
  props: {
    modelValue: {},
    floating: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    style: {},
    toolbarId: { default: "custom-toolbar" },
    zoom: { default: 1 },
    showAlign: { type: Boolean, default: false },
    showSize: { type: Boolean, default: false }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const internalId = bsonId();

const id = computed(() => `${props.toolbarId}-${internalId}`);

const editorOptions = {
  modules: {
    toolbar: `#${id.value}`,
  },
  placeholder: "Digite seu texto aqui...",
  theme: "snow",
};

const editorContent = ref<any>(new Delta());
const quillEditorRef = ref<InstanceType<typeof QuillEditor> | null>(null);

async function initialize() {
  try {
    const Quill = await loadQuill();

    const Size = Quill.import("attributors/style/size") as any;

    Size.whitelist = [
      "0.375em", // 6px
      "0.5em", // 8px
      "0.625em", // 10px
      "0.6875em", // 11px
      "0.75em", // 12px
      "0.8125em", // 13px
      "0.875em", // 14px
      "0.9375em", // 15px
      "1em", // 16px
      "1.0625em", // 17px
      "1.125em", // 18px
      "1.25em", // 20px
      "1.375em", // 22px
      "1.5em", // 24px
      "1.625em", // 26px
      "1.75em", // 28px
      "1.875em", // 30px
    ];

    Quill.register(Size, true);
  } catch (error) {
    console.error("Erro ao inicializar Quill:", error);
  }
}

function onEditorReady(_quill: any) {
  // O Quill está garantidamente carregado aqui.
  // Se precisar de algum ajuste pós-ready, faça neste bloco.
}

function update(value: any) {
  if (value === props.modelValue) {
    return;
  }

  emit("update", value);
}

function processDelta(value: any): any {
  if (!value) {
    return new Delta();
  }

  let parsedValue = value;

  if (typeof value === "string" && value.trim().startsWith("{")) {
    try {
      parsedValue = JSON.parse(value);
    } catch (e) {
      console.error("Erro ao fazer parse da string Delta:", e);
      return new Delta();
    }
  }

  if (parsedValue && typeof parsedValue === "object" && "ops" in parsedValue) {
    return new Delta(parsedValue);
  }

  return new Delta();
}

watch(
  () => props.modelValue,
  (newValue) => {
    editorContent.value = processDelta(newValue);
  },
);

// manda para o final do texto
watch(
  () => props.selected,
  (active) => {
    if (active) {
      requestAnimationFrame(() => {
        const editor = quillEditorRef.value?.getQuill();
        if (editor) {
          const length = editor.getLength();
          editor.setSelection(length, 0);
        }
      });
    }
  },
);

onMounted(async () => {
  await initialize();
  editorContent.value = processDelta(props.modelValue);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: id.value,
      class: _normalizeClass(["custom-toolbar", {
        floating: __props.floating,
        selected: __props.selected,
      }])
    }, [
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", { class: "ql-bold" }),
        _createElementVNode("button", { class: "ql-italic" }),
        _createElementVNode("button", { class: "ql-underline" })
      ], -1)),
      _createElementVNode("span", _hoisted_3, [
        (__props.showSize)
          ? (_openBlock(), _createElementBlock("select", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createStaticVNode("<option value=\"0.375em\" data-v-0293d812>6px</option><option value=\"0.5em\" data-v-0293d812>8px</option><option value=\"0.625em\" data-v-0293d812>10px</option><option value=\"0.6875em\" data-v-0293d812>11px</option><option value=\"0.75em\" data-v-0293d812>12px</option><option value=\"0.8125em\" data-v-0293d812>13px</option><option value=\"0.875em\" data-v-0293d812>14px</option><option value=\"0.9375em\" data-v-0293d812>15px</option><option value=\"1em\" data-v-0293d812>16px</option><option value=\"1.0625em\" data-v-0293d812>17px</option><option value=\"1.125em\" data-v-0293d812>18px</option><option value=\"1.25em\" data-v-0293d812>20px</option><option value=\"1.375em\" data-v-0293d812>22px</option><option value=\"1.5em\" data-v-0293d812>24px</option><option value=\"1.625em\" data-v-0293d812>26px</option><option value=\"1.75em\" data-v-0293d812>28px</option><option value=\"1.875em\" data-v-0293d812>30px</option>", 17)
            ]))]))
          : _createCommentVNode("", true),
        (__props.showAlign)
          ? (_openBlock(), _createElementBlock("select", _hoisted_5, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("option", { selected: "" }, null, -1),
              _createElementVNode("option", { value: "center" }, null, -1),
              _createElementVNode("option", { value: "right" }, null, -1),
              _createElementVNode("option", { value: "justify" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _cache[3] || (_cache[3] = _createElementVNode("select", { class: "ql-color" }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("select", { class: "ql-background" }, null, -1))
      ]),
      _cache[6] || (_cache[6] = _createStaticVNode("<span class=\"ql-formats\" data-v-0293d812><button class=\"ql-list\" value=\"ordered\" data-v-0293d812></button><button class=\"ql-list\" value=\"bullet\" data-v-0293d812></button></span><span class=\"ql-formats\" data-v-0293d812><button class=\"ql-clean\" data-v-0293d812></button></span>", 2))
    ], 10, _hoisted_2),
    _createVNode(_unref(QuillEditor), {
      ref_key: "quillEditorRef",
      ref: quillEditorRef,
      content: editorContent.value,
      "onUpdate:content": [
        _cache[0] || (_cache[0] = ($event: any) => ((editorContent).value = $event)),
        update
      ],
      options: editorOptions,
      "content-type": "delta",
      theme: "snow",
      onReady: onEditorReady,
      style: _normalizeStyle(_unref(styleZoom)(__props.style, __props.zoom))
    }, null, 8, ["content", "style"])
  ]))
}
}

})